export interface WFIndication {
  descriptor: string;
  labelOverride?: string;
  isOptional?: boolean;
}

export const heartWorkflowIndications: Array<WFIndication> = [
  // splines
  { descriptor: 'tp.eustachian_ridge_spline.pts', isOptional: true },
  // areas
  { descriptor: 'landing_zone_area' },
  { descriptor: 'tp.pl_ivc1.area' },
  { descriptor: 'tp.pl_svc1.area' },
  // distances
  { descriptor: 'var_basal_rv_ap', labelOverride: 'AP Basal RV at 5 mm' },
  { descriptor: 'var_basal_rv_sl', labelOverride: 'SL Basal RV at 5 mm' },
  { descriptor: 'var_basal_rv_tv_ap', labelOverride: 'AP Basal RV custom' },
  { descriptor: 'var_basal_rv_tv_sl', labelOverride: 'SL Basal RV custom' },
  { descriptor: 'var_ivc_to_tva_offset' },
  { descriptor: 'var_ivc_to_tva' },
  { descriptor: 'var_ra_height' },
  { descriptor: 'var_rv_depth' },
  { descriptor: 'var_rv_depth_apex' }
];
